// Account (DWM header): Aurora Avatar + email + caret, opening an Aurora Popover with plan, theme and Settings.
import { Avatar, AvatarFallback } from '@aurora-reactkit/components/avatar';
import { Divider } from '@aurora-reactkit/components/divider';
import { Popover, PopoverContent, PopoverTrigger } from '@aurora-reactkit/components/popover';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PLANS } from '../../domain/entitlements';
import { Icon } from '../icons';
import { personaById } from './personas';
import { usePlan } from './PlanProvider';
import { ThemeSwitch } from './ThemeSwitch';
import { openDemoMenu } from './demoBus';
import s from './Shell.module.css';

export function AccountMenu({ placement }: { placement: 'header' | 'top' }) {
  const [open, setOpen] = useState(false);
  const { persona, plan } = usePlan();
  const p = personaById(persona);
  const initial = p.name[0];

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger className={s.accountBtn} data-testid="account-menu-button">
        <span aria-hidden><Avatar size="lg"><AvatarFallback>{initial}</AvatarFallback></Avatar></span>
        <span className="visually-hidden">Account: </span>
        <span className={placement === 'top' ? 'visually-hidden' : s.accountEmail}>{p.name}</span>
        {placement === 'header' && <Icon name="chevron-down" size={12} className={s.caret} />}
      </PopoverTrigger>
      <PopoverContent side="bottom" align="end" aria-label="Account" data-testid="account-menu" className={s.popover} showCloseButton={false}>
        <div className={s.popBody}>
        <div className={s.popHead}>
          <Avatar size="lg" aria-hidden><AvatarFallback>{initial}</AvatarFallback></Avatar>
          <div>
            <p className="bodySmBold">{p.name}</p>
            <p className={`bodyXs ${s.muted}`}>{p.email} · {PLANS[plan].name}</p>
          </div>
        </div>
        <Divider />
        <p className={`bodyXsMedium ${s.muted}`}>Appearance</p>
        <ThemeSwitch />
        <Divider />
        <Link to="/settings" className={`bodySmMedium ${s.popLink}`} onClick={() => setOpen(false)}>
          <Icon name="gear" size={16} /> <span>Settings</span> <Icon name="chevron-right" size={12} className={s.caret} />
        </Link>
        <button type="button" className={`bodySmMedium ${s.popLink}`} onClick={() => { setOpen(false); openDemoMenu(); }} data-testid="account-demo">
          <Icon name="flask" size={16} /> <span>Demo menu</span> <kbd className={s.kbd}>⌘.</kbd>
        </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
